import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { initConsentDefaults, hardenAnalyticsConfig } from "./lib/analytics.ts";
//import { wireGlobalErrorHandlers } from "./lib/error-reporting.ts";
// import { sendError } from "./services/api/errors.ts";

initConsentDefaults();
hardenAnalyticsConfig();

//wireGlobalErrorHandlers(/*sendError*/);

createRoot(document.getElementById("root")!).render(<App />);
